import { Component, CUSTOM_ELEMENTS_SCHEMA, Input, OnInit } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { faExclamationCircle, faCheckCircle } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@Component({
    selector: 'app-immunization-status-modal',
    templateUrl: './immunization-status-modal.component.html',
    styleUrls: ['./immunization-status-modal.component.scss'],
    standalone: true,
    imports: [CommonModule, FormsModule, ReactiveFormsModule, IonicModule, FontAwesomeModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]})
export class ImmunizationStatusModalComponent implements OnInit {
    @Input() statuses: any[];

    //icons
    faExclamationCircle = faExclamationCircle;
    faCheckCircle = faCheckCircle;

    constructor(private modalCtrl: ModalController) {}

    ngOnInit(): void {/* empty */}

    close() {
        this.modalCtrl.dismiss();
    }
}
